__turbopack_context__.v({
  "active": "MissionTimeline-module__iPWj2a__active",
  "card": "MissionTimeline-module__iPWj2a__card",
  "cardDesc": "MissionTimeline-module__iPWj2a__cardDesc",
  "cardList": "MissionTimeline-module__iPWj2a__cardList",
  "cardTitle": "MissionTimeline-module__iPWj2a__cardTitle",
  "centerLine": "MissionTimeline-module__iPWj2a__centerLine",
  "centerPointWrap": "MissionTimeline-module__iPWj2a__centerPointWrap",
  "content": "MissionTimeline-module__iPWj2a__content",
  "drawn": "MissionTimeline-module__iPWj2a__drawn",
  "eyebrow": "MissionTimeline-module__iPWj2a__eyebrow",
  "icon": "MissionTimeline-module__iPWj2a__icon",
  "items": "MissionTimeline-module__iPWj2a__items",
  "left": "MissionTimeline-module__iPWj2a__left",
  "right": "MissionTimeline-module__iPWj2a__right",
  "row": "MissionTimeline-module__iPWj2a__row",
  "section": "MissionTimeline-module__iPWj2a__section",
  "show": "MissionTimeline-module__iPWj2a__show",
  "sub": "MissionTimeline-module__iPWj2a__sub",
  "text-muted": "MissionTimeline-module__iPWj2a__text-muted",
  "timelineWrap": "MissionTimeline-module__iPWj2a__timelineWrap",
  "title": "MissionTimeline-module__iPWj2a__title",
  "waypoint": "MissionTimeline-module__iPWj2a__waypoint",
});
